module.exports = __webpack_public_path__ + "static/media/upload_icon.6102eb56.svg";